export default "__VITE_ASSET__ClEKaYwE__"